export const CANCEL_PERSON_AVAILABILITY_EDIT_STATE = "cancelPersonAvailabilityEditState";
export const DELETE_AVAILABILITY = "deleteAvailability";
export const DELETE_PERSON_AVAILABILITY = "deleteAvailability";
export const FETCH_PERSON_AVAILABILITY_LIST = "r";
export const SAVE_EDITED_PERSON_AVAILABILITY = "saveEditedHoliday";
export const SAVE_AVAILABILITY = "saveAvailability";
export const SAVE_NEW_PERSON_AVAILABILITY = "rz";
export const SAVE_PERSON_AVAILABILITY = "updatePersonAvailability";
export const UPDATE_AVAILABILITY = "updateAvailability";
